module.exports = "/_next/static/images/LCTL-b200806faf527adcfb3de60f2b412135.png";